import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { NgxSpinnerService } from "ngx-spinner";

import { PatientService } from '../../../../services/patient.service';
import {BasicAgency, RestApiService} from '../../../../services/rest-api.service';
import { ToastService } from '../../../custom/messaging/toast/toast.service';


@Component({
  selector: '[class="celerity-app"]',
  templateUrl: './request-reset.component.html'
})
export class RequestResetComponent implements OnInit {
  email: string;
  agency:BasicAgency;

  constructor(private router: Router, private spinner: NgxSpinnerService, private rest: RestApiService,
              private patient: PatientService, private toast: ToastService) {}

  async ngOnInit() {
    // Definitely don't want to be signed in while resetting the password
    try{
      await this.spinner.show();
      const session = await Auth.currentSession();
      if (session.isValid()) {
        this.patient.currentPatient = null;
        await Auth.signOut();
      }
      await this.spinner.hide();
    }catch(err){
      await this.spinner.hide();
      if (err !== 'No current user'){
        console.log(this.rest.errorMessage(err));
      }
    }
    this.agency = this.patient.currentAgency;
  }

  async reset() {
    if (this.email) this.email = this.email.trim();
    if (this.email) {
      try{
        await this.spinner.show();
        await this.rest.resetPassword(this.email)
        await this.spinner.hide();
        this.toast.showSuccess('Your request has been received.  Check your e-mail for the next steps.');
        await this.router.navigateByUrl('/auth/landing');
      }catch(err){
        await this.spinner.hide();
        this.toast.showDanger("Error!  Request reset could not be processed.");
        console.log(this.rest.errorMessage(err));
      }
    } else this.toast.showWarning('Please enter your e-mail address');
  }
}
